import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

// Narrows an unvalidated URL search value to one of a closed tuple's members. A route's
// `validateSearch` receives whatever the address bar holds, so a hand-typed filter has to
// fall back to undefined rather than reach a query as a bogus enum value.
export function pick<T extends string>(options: readonly T[], value: unknown): T | undefined {
  return options.find((option) => option === value);
}

export function share(part: number, whole: number): string {
  return whole === 0 ? '—' : `${Math.round((part / whole) * 100)}%`;
}
